import Button from 'components/Button';
import Text from 'components/Text';
import styled from 'styled-components';
import clsx from 'clsx';
import service_delete_icon from '../../../v2/icons/service-delete-icon.svg';
import service_edit_icon from '../../../v2/icons/service-edit-icon.svg';
import RequestAdminPWCallback, {
  useRequestAdminPWCallbackRef,
} from 'widgets/RequestAdminLocalPW/Callback';
import ModalEditName, {
  useModalEditNameRef,
} from '../../ServicesSettingV2/ModalEditName';
import Box from 'components/Box';
import InputSearch from 'components/InputSearch';
import { IPackageProgram } from 'features/settingService/services/types/packageSetting';
import CreatePackageModal, { CreatePackageModalRef } from '../CreatePackageModal';
import { useRef } from 'react';
import Add from 'assets/Icons/add';
import colorTheme from 'constants/color';

type Props = {
  data: IPackageProgram[];
  activeCate: IPackageProgram | null;
  onChoosePackage: (id: string) => void;
  onEditNameCate: (id: string, value: string) => void;
  onDeletePackage: (id: string) => void;
};
const CategoryPart = ({
  activeCate,
  data = [],
  onChoosePackage,
  onEditNameCate,
  onDeletePackage,
}: Props) => {
  const packageModalRef = useRef<CreatePackageModalRef>(null);
  const modalEditNameRef = useModalEditNameRef();
  const pwRef = useRequestAdminPWCallbackRef();

  const handleEditNameCate = () => {
    modalEditNameRef.current?.open(activeCate?.name || '');
  };
  const handleDeletePackage = () => {
    if (!activeCate) return;
    pwRef.current?.open(() => onDeletePackage(activeCate.id));
  };

  return (
    <Container className='v2'>
      <CategoriesListStyled>
        <Header>
          <Box
            display='flex'
            alignItems='center'
            justifyContent='space-between'
            width='100%'
          >
            <Text variant='H5'>Packages</Text>
            <Button ntype='PRIMARY' cardCashier onClick={() => packageModalRef.current?.open()} iconElement={<Add fill={colorTheme.text_1} width={28} height={28}/>}>
              Add Package
            </Button>
          </Box>
          <InputSearch placeholder='Search categories' />
        </Header>
        <CategoriesListOverflow>
          <div className='content-scroll'>
            {data.map((o) => (
              <CategoryButtonV2
                key={o.id}
                type='button'
                className={clsx(activeCate?.id === o?.id && 'active')}
                onClick={() => onChoosePackage(o.id)}
              >
                {activeCate?.id === o?.id ? (
                  <div className='active-wrapper'>
                    <div className='category-item-wrap'>
                      <Text className='cate-name'>{o.name || ''}</Text>
                      <Text className='cate-services'>
                        {o.tiers.length || 0} items
                      </Text>
                    </div>
                    {activeCate.id !== 'add-on' && (
                      <div className='action-container'>
                        <button
                          type='button'
                          onClick={handleDeletePackage}
                          className='btn'
                        >
                          <img
                            src={service_delete_icon}
                            alt='service_delete_icon'
                            style={{ width: 32, height: 32 }}
                          />
                        </button>
                        <button
                          type='button'
                          onClick={handleEditNameCate}
                          className='btn btn-edit'
                        >
                          <img
                            src={service_edit_icon}
                            alt='service_edit_icon'
                            style={{ width: 32, height: 32 }}
                          />
                        </button>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className='category-item-wrap'>
                    <Text className='cate-name'>{o.name || ''}</Text>
                    <Text className='cate-services'>
                      {o.tiers.length || 0} items
                    </Text>
                  </div>
                )}
              </CategoryButtonV2>
            ))}
          </div>
        </CategoriesListOverflow>
      </CategoriesListStyled>
      {/* <AddCateButton onAddCategory={onAddCategory} /> */}
      {/* <Text mb={1} />
      <div className='title-div'>
        <ConfigCategories v2 />
        <ArrangeCateModal
          v2
          block
          height={3}
          icon='sortService'
          title='Pre-Order'
        />
      </div> */}
      <RequestAdminPWCallback v2 ref={pwRef} onlyAdmin />
      <ModalEditName
        v2
        ref={modalEditNameRef}
        onSubmit={(value) => onEditNameCate(activeCate?.id || '', value)}
      />
      <CreatePackageModal ref={packageModalRef} />
    </Container>
  );
};

export default CategoryPart;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 26rem;
  background: #fff;
  padding: 16px 16px;
  .title-div {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    gap: 16px;
    .title-text {
      flex: 1;
      color: #1d2129;
      font-family: 'Open Sans';
      font-size: 22px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }

  .content-scroll {
    gap: 8px;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;

  .CONTENT_2 {
    font-family: Poppins;
    font-size: 18px;
  }
`;

const CategoriesListStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
`;

const CategoryButtonV2 = styled.button`
  display: flex;
  height: 77px;
  padding: 8px 16px;
  align-items: center;
  align-self: stretch;
  border: 1px solid #e9edf2;
  background: #fcfcfd;
  box-shadow:
    0px 2px 4px 0px rgba(44, 35, 66, 0.4),
    0px 4px 8px -3px rgba(45, 35, 66, 0.3),
    0px -3px 0px 0px #d6d6e7 inset;

  .category-item-wrap {
    display: flex;
    flex-direction: column;
    align-items: start;
    flex: 1 0 0;

    .cate-name {
      color: #1d2129;
      font-family: Poppins;
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      text-align: left;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .cate-services {
      color: #505050;
      font-family: Poppins;
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }

  &.active {
    border: 1px solid #2d6772;
    background: #232f3e;
    box-shadow:
      0px 2px 4px 0px rgba(44, 35, 66, 0.4),
      0px 4px 8px -3px rgba(45, 35, 66, 0.3),
      0px -3px 0px 0px #d6d6e7 inset;

    .active-wrapper {
      display: flex;
      flex: 1;
      align-items: center;
      .category-item-wrap {
        flex-direction: column;
        align-items: start;
        .cate-name {
          color: #fff;
        }
        .cate-services {
          color: #cbd5e1;
        }
      }

      .action-container {
        display: flex;
        align-items: center;
        gap: 16px;

        button.btn {
          display: flex;
          width: 40px;
          height: 40px;
          justify-content: center;
          align-items: center;
          gap: 10px;
          border-radius: 4px;
          background: #fff1f6;

          &.btn-edit {
            border-radius: 4px;
            background: #c6e9ef;
          }
        }
      }
    }
  }
`;

const CategoriesListOverflow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  position: relative;
  z-index: 1;
  .content-scroll {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow-y: auto;
    scrollbar-width: none; /* Firefox 64 */
    &::-webkit-scrollbar {
      width: 0px;
      height: 8px;
      background-color: #f5f5f5;
    }
  }
`;
